/// <reference types="vite-plugin-svgr/client" />
import { ProfileRoutePathsEnum } from '@/modules/profile/routes/profileRouteConfig.types'

import { useLogout } from '@/hooks/useLogout.hook'

import LogoutIcon from '@/assets/icons/logout.svg?react'
import SettingsIcon from '@/assets/icons/settings.svg?react'
import ProfileIcon from '@/assets/icons/users.svg?react'

export const useAccountMenuItems = () => {
  const logout = useLogout()

  return [
    {
      icon: ProfileIcon,
      label: 'Profile',
      to: ProfileRoutePathsEnum.PROFILE,
    },
    {
      icon: SettingsIcon,
      label: 'Settings',
      to: ProfileRoutePathsEnum.SETTINGS,
    },
    {
      icon: LogoutIcon,
      label: 'Logout',
      onClick: logout,
      to: '',
    },
  ]
}
